import { useClientPortalAPI } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

export function GroupFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/apply-links/customer-groups/options/"
  );

  return (
    <Picker
      isLoading={isLoading}
      selectedKeys={params.customer_group_id?.split(",") || []}
      onSelectionChange={(keys) =>
        setParam("customer_group_id", Array.from(keys))
      }
      label={t("Group")}
      selectionMode="multiple"
      showActionBar
      items={data}
      testID="apply-link-group-filter"
    />
  );
}
